/*  Size‑link + EasySize alignment script (v2)
    — centred vertical alignment
    — only one EasySize element displayed */

document.addEventListener('DOMContentLoaded', () => {
  if (!window.location.pathname.includes('/products/')) return;

  /* ---------- build the two‑link row ---------- */
  const originalButton = document.querySelector('#AddToCart');
  if (!originalButton) return;

  const linksContainer = document.createElement('div');
  linksContainer.id = 'es-links-container';
  Object.assign(linksContainer.style, {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',     // centred instead of baseline
    gap: '8px',
    width: '100%',
    marginBottom: '15px',
    marginTop: '10px'
  });
  originalButton.parentNode.parentNode.insertBefore(
    linksContainer,
    originalButton.parentNode
  );

  /* left link */
  const sizeLink = document.createElement('a');
  sizeLink.textContent = 'Er din størrelse udsolgt?';
  sizeLink.href = '#';
  Object.assign(sizeLink.style, {
    textDecoration: 'underline',
    color: '#666',
    cursor: 'pointer',
    fontSize: '12px',
    display: 'inline-flex',
    alignItems: 'center',
    textAlign: 'left'
  });
  linksContainer.appendChild(sizeLink);

  /* right placeholder */
  const quizPlaceholder = document.createElement('div');
  quizPlaceholder.id = 'easysize-placeholder';
  quizPlaceholder.style.display = 'inline-block';
  linksContainer.appendChild(quizPlaceholder);

  sizeLink.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.klaviyo-bis-trigger')?.click();
  });

  /* ---------- move EasySize elements ---------- */
  function moveButtonToPlaceholder(el) {
    quizPlaceholder.innerHTML = '';                // ensure only one element
    if (el.parentNode === quizPlaceholder) return; // already placed

    el.parentNode?.removeChild(el);

    Object.assign(el.style, {
      textDecoration: 'underline',
      color: '#666',
      cursor: 'pointer',
      fontSize: '12px',
      background: 'none',
      border: 'none',
      padding: '0',
      margin: '0',
      display: 'inline-flex',     // inline‑flex centres icon + text
      alignItems: 'center',
      textAlign: 'right'
    });

    quizPlaceholder.appendChild(el);
    el.classList.add('moved');
  }

  function moveEasysizeElements() {
    const selectors = [
      '#easysize_button',
      '.easysize_button__returning',
      '.easysize_button__out_of_stock',
      '.easysize_recommendation'
    ];
    let moved = false;
    selectors.forEach(sel => {
      const el = document.querySelector(sel);
      if (el && !el.classList.contains('moved')) {
        moveButtonToPlaceholder(el);
        moved = true;
      }
    });
    return moved;
  }

  new MutationObserver(moveEasysizeElements).observe(document.body, {
    childList: true,
    subtree: true
  });
  const poll = setInterval(moveEasysizeElements, 1000);
  setTimeout(() => clearInterval(poll), 30000);

  /* ---------- hide Klaviyo trigger ---------- */
  const hideKlaviyo = () => {
    const k = document.querySelector('.klaviyo-bis-trigger');
    if (k) k.style.display = 'none';
  };
  hideKlaviyo();
  new MutationObserver(hideKlaviyo).observe(document.body, {
    childList: true,
    subtree: true
  });

  /* ---------- sold‑out button override ---------- */
  function hideQuantitySelectors() {
    ['.product-form__quantity', '[name="quantity"]', '.quantity-selector', '.quantity']
      .forEach(sel => document.querySelectorAll(sel).forEach(el => el.style.display = 'none'));
  }

  function triggerKlaviyo(e) {
    e.preventDefault();
    document.querySelector('.klaviyo-bis-trigger')?.click();
  }

  function updateButton() {
    const txt = originalButton.querySelector('.single-add-to-cart-button--text');
    const oos = originalButton.disabled ||
      (txt && txt.textContent.trim().toLowerCase().includes('udsolgt'));

    if (oos) {
      originalButton.disabled = false;
      Object.assign(originalButton.style, { display: 'block', pointerEvents: 'auto', cursor: 'pointer', opacity: '1' });
      (txt ? txt : originalButton).textContent = 'Få besked når produktet er tilbage på lager';
      originalButton.classList.remove('sold-out');
      originalButton.addEventListener('click', triggerKlaviyo, { once: true });
      hideQuantitySelectors();
      hideKlaviyo();
    } else {
      originalButton.style.display = '';
    }
  }

  updateButton();
  setInterval(updateButton, 1500);

  document.addEventListener('change', (e) => {
    if (e.target.matches('select[name^="options"], input[name^="options"]')) {
      setTimeout(updateButton, 300);
    }
  });
  document.addEventListener('click', (e) => {
    if (e.target.closest('.swatch,[data-option-value],[data-value],.product-form__input')) {
      setTimeout(updateButton, 300);
    }
  });
});
